// import * as Sentry from "@sentry/vue";
import FcDesigner from "@form-create/antd-designer";
import DeptSelect from "@main/components/DeptSelect/index.vue";
import ItemRequisitionTable from "@main/components/ItemRequisitionTable/index.vue";
import PositionSelect from "@main/components/PositionSelect/index.vue";
import ProcurementRequestTable from "@main/components/ProcurementRequestTable/index.vue";
import UserSelect from "@main/components/UserSelect/index.vue";
import permissionDirective from "@main/directives/permission";
import antd from "ant-design-vue";
import { createApp } from "vue";
import { initConfig } from "@/config/initConfig";
import global from "../global";
import i18n from "../i18n";
import pinia from "../pinia";
import App from "./App.vue";
import router from "./router";

import "@/assets/styles/index.css";
import "@/assets/styles/tailwind/index.css";
import "ant-design-vue/dist/reset.css";

const app = createApp(App);

app.use(router);
app.use(i18n);
app.use(pinia);
app.use(global);

app.use(antd);
app.directive("permission", permissionDirective);
app.use(FcDesigner);
app.use(FcDesigner.formCreate);
FcDesigner.component("UserSelect", UserSelect);
FcDesigner.component("DeptSelect", DeptSelect);
FcDesigner.component("PositionSelect", PositionSelect);
FcDesigner.component("ProcurementRequestTable", ProcurementRequestTable);
FcDesigner.component("ItemRequisitionTable", ItemRequisitionTable);

initConfig();

// @TODO: Sentry 集成待确认
// const mode = import.meta.env.MODE;

// if (mode === "production") {
// 	Sentry.init({
// 		app,
// 		dsn: "https://53c1e325a553e7d2c18820406d31f548@o4510509791248384.ingest.de.sentry.io/4510509801930832",

// 		// Setting this option to true will send default PII data to Sentry.
// 		// For example, automatic IP address collection on events
// 		sendDefaultPii: true,
// 	});
// }

app.mount("#app");
